/**
 * Combine ~~all reducers~~ a minimal subset of reducers to show the login screen
 * in this file and export the combined reducers.
 */
import { combineReducers } from 'redux-immutable'

import projectSelection from './containers/ProjectSelection/reducer'
import planSelection from './containers/PlanSelection/reducer'
import projectSettings from './containers/ProjectSettings/reducer'
import importReducer from './containers/plan-import/reducer'
import importRevision from './containers/plan-import-revision/reducer'
import importStatus from './containers/plan-import-status/reducer'
import taskList from './containers/TaskList/reducer'
import manageUsers from './containers/ManageUsers/reducer'
import teamManagementUsers from './containers/TeamManagementUsers/reducer'
import datasets from './containers/Datasets/reducer'
import datasetEdit from './containers/DatasetEdit/reducer'
import media from './containers/Media/reducer'
import filter from './containers/Filter/reducer'
import groups from './containers/groups/reducer'
import group from './containers/group-details/reducer'
import reports from './containers/Reports/reducer'
import createProject from './containers/CreateProject/reducer'
import planViewerNew from './containers/plan-viewer/reducer'
import plan from './containers/plan-map/reducer'
import pinOptions from './containers/pin-details/reducer'
import folderSelectBox from './containers/FolderSelectBox/reducer'
import mobileTopBar from './containers/TopBarMobile/reducer'

/**
 * Creates the main reducer with the asynchronously loaded ones
 */
export default function createReducer(asyncReducers) {
  return combineReducers({
    projectSelection,
    planSelection,
    projectSettings,
    import: importReducer,
    importRevision,
    importStatus,
    taskList,
    manageUsers,
    teamManagementUsers,
    datasets,
    datasetEdit,
    media,
    filter,
    groups,
    group,
    reports,
    createProject,
    planViewerNew,
    plan,
    pinOptions,
    folderSelectBox,
    mobileTopBar,
    ...asyncReducers
  })
}
